var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"href":_vm.url,"target":"_blank","color":"amber lighten-1","light":"","small":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v(" mdi-open-in-new ")]),_vm._v(" Pythia ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }